import Tag from './src/tag.vue';
import { SFCWithInstall } from '@touchvue/utils';
export declare const ToTag: SFCWithInstall<typeof Tag>;
export default ToTag;
export * from './src/instance';
